import Share from '../src/Share/index.tsx';
export default Share;
